import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
    className?: string;
    size?: 'default' | 'sm' | 'lg';
}

export const Button: React.FC<ButtonProps> = ({
    children,
    className = '',
    size = 'default',
    ...props
}) => {
    const sizeClasses = {
        default: "py-2 px-4",
        sm: "py-1 px-3 text-sm",
        lg: "py-3 px-6 text-lg"
    };

    return (
        <button
            className={`font-semibold rounded-lg transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed ${sizeClasses[size]} ${className}`}
            {...props}
        >
            {children}
        </button>
    );
};